
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-teal-900 via-teal-800 to-teal-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-16">
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-8 sm:gap-12">
          {/* Brand Column */}
          <div className="col-span-2 lg:col-span-2">
            <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
              <img 
                src="https://public.readdy.ai/ai/img_res/d0bdf95a-47b8-422f-81da-3c55b8a00c41.png" 
                alt="Desguace Castelldefels" 
                className="h-10 sm:h-12 w-auto"
              />
              <div className="flex flex-col">
                <span className="font-bold text-base sm:text-lg leading-tight">DESGUACE</span>
                <span className="font-bold text-base sm:text-lg leading-tight">CASTELLDEFELS</span>
              </div>
            </div>
            <p className="text-teal-100 mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base">
              Tu <strong>desguace de confianza en Castelldefels</strong> desde 1995. Especialistas en piezas de recambio originales con más de 500 vehículos en stock.
            </p>
            
            {/* Newsletter */}
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="Tu email"
                className="flex-1 px-3 sm:px-4 py-2 bg-white/10 border border-white/30 rounded-lg text-white placeholder-teal-200 focus:outline-none focus:ring-2 focus:ring-white/50 text-sm"
              />
              <button className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-orange-500 rounded-lg hover:bg-orange-600 transition-colors flex-shrink-0">
                <i className="ri-notification-line text-base sm:text-lg"></i>
              </button>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h3 className="font-bold text-base sm:text-lg mb-3 sm:mb-4">Servicios</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <a href="#servicios" className="text-teal-100 hover:text-white transition-colors text-xs sm:text-sm whitespace-nowrap">
                  Despiece de Vehículos
                </a>
              </li>
              <li>
                <a href="#servicios" className="text-teal-100 hover:text-white transition-colors text-xs sm:text-sm whitespace-nowrap">
                  Venta de Piezas
                </a>
              </li>
              <li>
                <a href="#servicios" className="text-teal-100 hover:text-white transition-colors text-xs sm:text-sm whitespace-nowrap">
                  Recogida de Vehículos
                </a>
              </li>
              <li>
                <a href="#servicios" className="text-teal-100 hover:text-white transition-colors text-xs sm:text-sm whitespace-nowrap">
                  Entrega Inmediata
                </a>
              </li>
            </ul>
          </div>

          {/* Information Column */}
          <div>
            <h3 className="font-bold text-base sm:text-lg mb-3 sm:mb-4">Información</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <a href="#sobre-nosotros" className="text-teal-100 hover:text-white transition-colors text-xs sm:text-sm whitespace-nowrap">
                  Sobre Nosotros
                </a>
              </li>
              <li>
                <a href="#testimonios" className="text-teal-100 hover:text-white transition-colors text-xs sm:text-sm whitespace-nowrap">
                  Testimonios
                </a>
              </li>
              <li>
                <a href="#faq" className="text-teal-100 hover:text-white transition-colors text-xs sm:text-sm whitespace-nowrap">
                  Preguntas Frecuentes
                </a>
              </li>
              <li>
                <a href="#contacto" className="text-teal-100 hover:text-white transition-colors text-xs sm:text-sm whitespace-nowrap">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div className="col-span-2 sm:col-span-1">
            <h3 className="font-bold text-base sm:text-lg mb-3 sm:mb-4">Contacto</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-orange-400 mt-0.5 flex-shrink-0"></i>
                <a href="tel:+34932932913" className="text-teal-100 hover:text-white transition-colors text-xs sm:text-sm whitespace-nowrap">
                  +34 932 932 913
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-orange-400 mt-0.5 flex-shrink-0"></i>
                <a href="mailto:info@desguacecastelldefels.com" className="text-teal-100 hover:text-white transition-colors text-xs sm:text-sm break-all">
                  info@desguacecastelldefels.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-orange-400 mt-0.5 flex-shrink-0"></i>
                <span className="text-teal-100 text-xs sm:text-sm">
                  Castelldefels, Barcelona
                </span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line text-orange-400 mt-0.5 flex-shrink-0"></i>
                <span className="text-teal-100 text-xs sm:text-sm">
                  Lun-Vie: 9:00-19:00<br />Sáb: 9:00-14:00
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-teal-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            {/* Copyright */}
            <p className="text-teal-200 text-xs sm:text-sm text-center sm:text-left">
              © {currentYear} Desguace Castelldefels. Todos los derechos reservados.
            </p>

            {/* Social Media */}
            <div className="flex items-center gap-3 sm:gap-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center border border-teal-600 rounded-lg hover:bg-white hover:text-teal-900 transition-colors"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-base sm:text-lg"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center border border-teal-600 rounded-lg hover:bg-white hover:text-teal-900 transition-colors"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-base sm:text-lg"></i>
              </a>
              <a
                href="https://www.google.com/maps"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center border border-teal-600 rounded-lg hover:bg-white hover:text-teal-900 transition-colors"
                aria-label="Google"
              >
                <i className="ri-google-fill text-base sm:text-lg"></i>
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center border border-teal-600 rounded-lg hover:bg-white hover:text-teal-900 transition-colors"
                aria-label="YouTube"
              >
                <i className="ri-youtube-fill text-base sm:text-lg"></i>
              </a>
            </div>

            {/* Legal Links */}
            <div className="flex items-center gap-4">
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
